<div
  class="rounded-full w-10 h-5 flex justify-center items-center leading-0"
  [class]="getColorClass()"
>
  @if(total()) {
  <span class="text-xs">{{ total() }}</span>
  }
</div>
